import { gql, TypedDocumentNode } from '@apollo/client'
import { IEmailManagementConfig } from 'pages/agency-group-management/interface'

type IPageInfo = {
  currentPage: number
  totalPages: number
  totalItems: number
  itemsPerPage: number
  hasNextPage: boolean
  hasPreviousPage: boolean
}

type GetAllEmailManagementConfigQuery = {
  getAllEmailManagementConfig: {
    items: IEmailManagementConfig[]
    pageInfo: IPageInfo
  }
}

type GetAllEmailManagementConfigVariables = {
  page: number
  limit: number
}

export const GET_ALL_EMAIL_MANAGEMENT_CONFIG: TypedDocumentNode<
  GetAllEmailManagementConfigQuery,
  GetAllEmailManagementConfigVariables
> = gql`
  query GetAllEmailManagementConfig {
    getAllEmailManagementConfig {
      items {
        startSubject
        cancelSubject
        emailManagementConfigId
        subEmailManagementConfig {
          subEmailManagementConfigId
          sendingEmailSubject
          emailTemplateURL
          textTemplateURL
          action
          step
          tDayConfig {
            configId
            type
            isActive
            isDeleted
            key
            value
          }
        }
      }
      pageInfo {
        currentPage
        totalPages
        totalItems
        itemsPerPage
        hasNextPage
        hasPreviousPage
      }
    }
  }
`
